import { InvoiceStatus } from 'shared/types'
import { COLORS } from './InvoiceStatus.constants'

export const determineDotColor = (status: InvoiceStatus) => {
  if (status === InvoiceStatus.ActionRequired) return COLORS.red
  return COLORS.green
}
